import $i18n from '@/i18n';
import { Icon } from '@b-design/fusion';
import Space from '@/components/Space';
import { formatTime } from '@/utils';
import ColorTags from '@/components/ColorTags';
import { getMemberStatus } from '@/utils/status.tsx';

export const urlEmun = {
  add: '/rest/intercnn/app/auth/add',
  delete: '/rest/intercnn/app/auth/delete',
};

const handleFilters = (values) => {
  const filter = [];
  for (const [key, value] of Object?.entries(values)) {
    filter?.push({ label: value, value: key });
  }
  return filter;
};

const roleEmun = {
  ADMIN: $i18n.get({
    id: 'aopf.pages.member.actionSetAsAdmin',
    dm: '管理员',
  }),
  DEVELOPER: $i18n.get({
    id: 'aopf.pages.member.actionSetAsDeveloper',
    dm: '开发者',
  }),
};

const roleFilters = handleFilters(roleEmun);

const statusEmun = {
  ACTIVATE: $i18n.get({
    id: 'aopf.pages.getMemberStatus.active',
    dm: '激活',
  }),
  BLOCKED: $i18n.get({
    id: 'aopf.pages.getMemberStatus.disabled',
    dm: '冻结',
  }),
};

const statusFilters = handleFilters(statusEmun);

const renderTitle = (_v, _i, record) => {
  return (
    <>
      {record?.userNick}
      <br />
      <span style={{ color: 'rgba(146,152,172,1)' }}>{record?.account}</span>
    </>
  );
};

export const renderActionItem = ({ icon, content, disable = false }) => {
  return (
    <Space
      style={disable ? { color: 'rgba(212,214,225,1)' } : { cursor: 'pointer' }}
      marginRight={6}
    >
      <Icon type={icon} size={'xs'} />
      {content}
    </Space>
  );
};

export const miniAppMemberColumns = [
  {
    title: $i18n.get({ id: 'aopf.pages.member.columnsNames', dm: '名称' }),
    dataIndex: 'userNick',
    width: 140,
    cell: renderTitle,
  },
  {
    title: $i18n.get({ id: 'aopf.pages.member.columnsRole', dm: '角色' }),
    dataIndex: 'role',
    width: 140,
    cell: (value) => roleEmun[value] || '',
    filters: roleFilters,
    filterMode: 'single',
  },
  {
    title: $i18n.get({ id: 'aopf.pages.member.columnsStatus', dm: '状态' }),
    dataIndex: 'status',
    width: 140,
    cell: (value) => <ColorTags {...getMemberStatus(value)} />,
    filters: statusFilters,
    filterMode: 'single',
  },
  {
    title: $i18n.get({ id: 'aopf.pages.member.columnsCreatedOn', dm: '创建时间' }),
    dataIndex: 'gmtCreate',
    width: 140,
    cell: (value) => formatTime(value),
  },
];
